import { render } from "./CreateImplementacao.vue?vue&type=template&id=790b7a0e"
import script from "./CreateImplementacao.vue?vue&type=script&lang=js"
export * from "./CreateImplementacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__